import { createContext, useContext } from 'react';
import type { Segments } from '@trinity/chat';

export type DashboardContextValue = {
  segment: Segments.Segment;
  name: string;
  metadata: Segments.SegmentMetadata;
};

export type SegmentDashboardIds = {
  projectId: number;
  projectParentId: number;
  slug: string;
  segmentId: number;
};

export const CurrentSegmentIdsContext = createContext<SegmentDashboardIds>({} as SegmentDashboardIds);
export const SegmentationDashboardContext = createContext<DashboardContextValue>({} as DashboardContextValue);

export function useSegmentationDashboardContext() {
  const context = useContext(SegmentationDashboardContext);
  if (!context) {
    throw new Error(
      'useSegmentationDashboardContext must be used within a SegmentationDashboardProvider',
    );
  }
  return context;
}

export function useCurrentSegmentIdsContext() {
  const context = useContext(CurrentSegmentIdsContext);
  if (!context) {
    throw new Error(
      'useCurrentSegmentIdsContext must be used within a CurrentSegmentIdsProvider',
    );
  }
  return context;
}